// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"38":"1ca482d4","453":"2d0fec30"}[chunkId] + ".chunk.js");